import React from 'react';
import _ from 'lodash';
export const getFieldRequirements = (field, userRequirements) => {
    if (userRequirements) {
        if (field === 'username') {
            return userRequirements.nameRequirements;
        }
        if (field === 'password') {
            const requirements = userRequirements.passwordRequirements;
            // password requirements has min/max char that we need to use to generate unicode range
            const acceptableSpecialChars = generateSpecialCharUnicodeRange(requirements.minCharAllowed, requirements.maxCharAllowed);
            return Object.assign({}, requirements, { acceptableSpecialChars });
        }
    }
};
// TODO: Need to move away from dangerouslySetInnerHTML.
export const getSpecialCharsAsHtml = (acceptableSpecialChars) => {
    // set special chars string as html, to interpret unicode html entities
    if (acceptableSpecialChars) {
        return React.createElement("span", { dangerouslySetInnerHTML: { __html: acceptableSpecialChars.replace(/\\u00/g, '&#x') } });
    }
    return undefined;
};
export const isUserNameEqualToEmail = (username, email) => {
    return _.isEqual(_.toLower(_.trim(username)), _.toLower(_.trim(email)));
};
export const isUserNameContainedInPassword = (password, username) => {
    if (!password || !username)
        return false;
    return _.includes(_.toLower(_.trim(password)), _.toLower(_.trim(username)));
};
export const doesPasswordContainForbiddenKeywords = (password) => {
    if (!password)
        return false;
    const passwordAllLowerCase = password.toLowerCase();
    if (passwordAllLowerCase.includes('welcome123') ||
        passwordAllLowerCase.includes('welcome01') ||
        passwordAllLowerCase.includes('password')) {
        return true;
    }
    return false;
};
export const isUserNameValid = (requirements, username, email) => {
    if (!requirements) {
        return false;
    }
    // separate from dynamic requirements, don't allow username to be same as login email
    if (isUserNameEqualToEmail(username, email)) {
        return false;
    }
    const { minLength, maxLength, minDigitCount, minSpecialCount, acceptableSpecialChars, } = requirements.nameRequirements;
    if (!isRequiredLengthValid(username, minLength, maxLength)) {
        return false;
    }
    if (!isRequiredDigitsValid(username, minDigitCount)) {
        return false;
    }
    if (!isRequiredSpecialCharsValid(username, minSpecialCount, acceptableSpecialChars)) {
        return false;
    }
    return true;
};
export const isPasswordValid = (password, requirements, username) => {
    if (!requirements) {
        return false;
    }
    if (username) {
        // separate from dynamic requirements, don't allow password to contain username
        if (isUserNameContainedInPassword(password, username)) {
            return false;
        }
    }
    const { minLength, maxLength, minLowerCount, minUpperCount, minDigitCount, minSpecialCount, minCharAllowed, maxCharAllowed, } = requirements.passwordRequirements;
    const acceptableSpecialChars = generateSpecialCharUnicodeRange(minCharAllowed, maxCharAllowed);
    if (!isRequiredLengthValid(password, minLength, maxLength)) {
        return false;
    }
    if (!isRequiredDigitsValid(password, minDigitCount)) {
        return false;
    }
    if (!isRequiredLowercaseValid(password, minLowerCount)) {
        return false;
    }
    if (!isRequiredUppercaseValid(password, minUpperCount)) {
        return false;
    }
    if (!isRequiredSpecialCharsValid(password, minSpecialCount, acceptableSpecialChars)) {
        return false;
    }
    if (doesPasswordContainForbiddenKeywords(password)) {
        return false;
    }
    return true;
};
const getRequirementsRegex = (minLength, maxLength, acceptableSpecialChars) => {
    // Escape hyphen in acceptableSpecialChars to ensure it's treated as a literal character
    const escapedSpecialChars = acceptableSpecialChars ? acceptableSpecialChars.replace(/-/g, '\\-') : '';
    return new RegExp(`^[a-z0-9${escapedSpecialChars}-]{${minLength},${maxLength || ''}}$`, 'i');
};
export const isRequiredLengthValid = (value, minLength, maxLength) => {
    // pass in current value as acceptable special chars, to only validate length
    const re = getRequirementsRegex(minLength, maxLength, _.escapeRegExp(value));
    return re.test(value);
};
export const isRequiredSpecialCharsValid = (value, minSpecialCount, acceptableSpecialChars) => {
    const re = getRequirementsRegex(minSpecialCount, 0, acceptableSpecialChars);
    if (acceptableSpecialChars) {
        return (re.test(value) &&
            (!minSpecialCount || countNumberOfChars(value, new RegExp(`[${acceptableSpecialChars}]`)) >= minSpecialCount));
    }
    return true;
};
export const isRequiredDigitsValid = (value, minDigitCount) => {
    if (minDigitCount) {
        return countNumberOfChars(value, /\d/) >= minDigitCount;
    }
    return true;
};
export const isRequiredLowercaseValid = (value, minLowerCount) => {
    if (minLowerCount) {
        return countNumberOfChars(value, /[a-z]/) >= minLowerCount;
    }
    return true;
};
export const isRequiredUppercaseValid = (value, minUpperCount) => {
    if (minUpperCount) {
        return countNumberOfChars(value, /[A-Z]/) >= minUpperCount;
    }
    return true;
};
const countNumberOfChars = (value, charMatch) => {
    return _.sumBy(value, c => (charMatch.test(c) ? 1 : 0));
};
const generateSpecialCharUnicodeRange = (minChar, maxChar) => {
    let range = '';
    if (minChar && maxChar) {
        // generate ranges for non-special chars that need to be excluded
        const numbersAndLettersRange = [
            ...generateUnicodeDecimalRange('0', '9'),
            ...generateUnicodeDecimalRange('A', 'Z'),
            ...generateUnicodeDecimalRange('a', 'z'),
        ];
        const charRange = generateUnicodeDecimalRange(minChar, maxChar);
        for (let i = 0; i < charRange.length; i++) {
            if (!_.includes(numbersAndLettersRange, charRange[i])) {
                var hex = charRange[i].toString(16);
                range += `\\u${'0000'.substring(0, 4 - hex.length)}${hex}`;
            }
        }
    }
    return range;
};
const generateUnicodeDecimalRange = (minChar, maxChar) => {
    const range = [];
    const minCodePoint = minChar.codePointAt(0) || 0;
    const maxCodePoint = maxChar.codePointAt(0) || -1;
    for (let i = minCodePoint; i <= maxCodePoint; i++) {
        range.push(i);
    }
    return range;
};
//# sourceMappingURL=Requirements.js.map